// Modules
import React from 'react'

// Routes
import Routes from './routes/Main'

// Components
import Page from 'components/layout/page/Page'

// Hooks
// import useLanguage from 'hooks/system/useLanguage'

// Styles
import './Login.scss'

// Page: Login
function Login () {
	// Data
	// const { translate } = useLanguage('pages.login')

	// Render
	return (
		<Page
			isPublic
			name="login">
			<Routes />
		</Page>
	)
}

// Export
export default Login
